export enum PaymentType {
  Coupon = 'coupon',
  Custom = 'custom',
}

export enum CustomPaymentType {
  Brilla = 'brilla',
  Distributed = 'distributed',
}
